import { render, staticRenderFns } from "./trial-duration-explanation.vue?vue&type=template&id=b56e3078&scoped=true&"
import script from "./trial-duration-explanation.vue?vue&type=script&lang=js&"
export * from "./trial-duration-explanation.vue?vue&type=script&lang=js&"
import style0 from "./trial-duration-explanation.vue?vue&type=style&index=0&id=b56e3078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56e3078",
  null
  
)

export default component.exports